module.exports = __webpack_public_path__ + "fonts/c40d29b5bafe2363be6afb8d7218d981.svg";